import React from 'react';
import { Grid } from '@mui/material';

import { NumberTextField, SearchSelectField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ItemsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={{ sm: 9, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="item_title"
					label={t('DETAILS_ITEMS_FIELD_TITLE')}
					value={props.model.item_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* ERP ID */}
				<SimpleTextField
					name="item_erp_id"
					label={t('DETAILS_ITEMS_FIELD_ERP_ID')}
					value={props.model.item_erp_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ITEM TYPES */}
				<SearchSelectField
					name="item_itty_id"
					label={t('DETAILS_ITEMS_FIELD_TYPE')}
					systable="items_types"
					value={props.model.item_itty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* UNIT OF MEASURE */}
				<SearchSelectField
					name="item_itum_id"
					label={t('DETAILS_ITEMS_FIELD_UNITOFMEASURE')}
					systable="items_unitsofmeasure"
					value={props.model.item_itum_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* SERIES */}
				<SearchSelectField
					name="item_itsr_id"
					label={t('DETAILS_ITEMS_FIELD_SERIES')}
					systable="items_series"
					value={props.model.item_itsr_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* MEASURE */}
				<SearchSelectField
					name="item_itms_id"
					label={t('DETAILS_ITEMS_FIELD_MEASURE')}
					systable="items_measures"
					value={props.model.item_itms_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* ORDER MIN QTY */}
				<NumberTextField
					name="item_ords_qty_min"
					label={t('DETAILS_ITEMS_FIELD_ORDSMINQTY')}
					value={props.model.item_ords_qty_min}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* ORDER MULTIPLE */}
				<NumberTextField
					name="item_ords_multiple"
					label={t('DETAILS_ITEMS_FIELD_ORDSMULTIPLE')}
					value={props.model.item_ords_multiple}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
